import request from "./../utils/request";

export const CALENDAR_API = {
    listEvents: (userIds, startDate, endDate) => {
        console.log("CALENDAR_API.listEvents ", { userIds, startDate, endDate });
        return request({
            url: `/calendar/list-events`,
            method: "get",
            params: {
                userIds,
                startDate,
                endDate,
            },
        }).then((res) => res.data);
    },
};

export function createCalendarEvent(payload) {
    return request({
        url: "/calendar",
        method: "post",
        data: {
            payload,
        },
    });
}

export function updateCalendarEvent(eventId, payload) {
    return request({
        url: `/calendar/${eventId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarEvents(calendarIds, userId, startDate, endDate) {
    return request({
        url: `/calendar/${userId}`,
        method: "get",
        params: {
            calendarIds,
            startDate,
            endDate,
        },
    });
}

export function getSelectUserCalendarEvents() {}

export function getEventDetail(eventId) {
    return request({
        url: `/calendar/detail/${eventId}`,
        method: "get",
    });
}

export function deleteCalendarEvent(payload) {
    return request({
        url: `/calendar/event`,
        method: "delete",
        data: {
            userId: payload.userId,
            calendarId: payload.calendarId,
            eventId: payload.eventId,
            deleteType: payload.deleteType,
        },
    });
}

export function updateCalendarSettings(userId, payload) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarSettings(userId) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "get",
    });
}

export function getTaskEvents(userId) {
    return request({
        url: `/calendar/tasks/${userId}`,
        method: "get",
    });
}

export function markCompletedTask(eventId) {
    return request({
        url: `/calendar/mark-completed-task/${eventId}`,
        method: "put",
    });
}

export function isEnableUserAccount(userId) {
    return request({
        url: `/calendar/is-calendar-feature-enabled/${userId}`,
        method: "get",
    });
}

export function createDefaultCalendar(userId, userName) {
    return request({
        url: `/calendar/create-default-calendar/${userId}`,
        method: "post",
        data: {
            userName,
        },
    });
}

export function getUserCalendars(userId) {
    return request({
        url: `/calendar/user-calendars/${userId}`,
        method: "get",
    });
}

export function createCalendar(userId, payload) {
    return request({
        url: `/calendar/create-calendar/${userId}`,
        method: "post",
        data: {
            payload,
        },
    });
}

export function updateCalendarColor(userId, payload) {
    return request({
        url: `/calendar/update-calendar-color/${userId}`,
        method: "put",
        data: {
            payload,
        },
    });
}

export function getCalendarList(userId, userName) {
    return request({
        url: `/calendar/calendar-list/${userId}`,
        method: "get",
        params: {
            userName,
        },
    });
}

export function calendarDisconnect(userId, authId, isDeleteAll) {
    return request({
        url: `/calendar/calendar-disconnect/${userId}`,
        method: "get",
        params: {
            authId,
            isDeleteAll,
        },
    });
}

export function getTodayEvents(userId) {
    return request({
        url: `/calendar/today-events/${userId}`,
        method: "get",
    });
}

export function updateSetting(userId, setting, value) {
    return request({
        url: `/calendar/settings/${userId}`,
        method: "put",
        params: {
            setting,
            value,
        },
    });
}

export function getVisitorEvents(visitorId, page, pageSize) {
    return request({
        url: `/calendar/visitor-events/${visitorId}`,
        method: "get",
        params: {
            page,
            pageSize,
        },
    });
}

export function changeVisibility(calendarId, visibility) {
    return request({
        url: `/calendar/change-visibility/${calendarId}`,
        method: "put",
        params: {
            visibility,
        },
    });
}

export function getCalendarDetail(calendarId) {
    return request({
        url: `/calendar/visibility/${calendarId}`,
        method: "get",
    });
}

export function deleteCalendar(userId, calendarId, isDeleteEvents) {
    return request({
        url: `/calendar/${calendarId}`,
        method: "delete",
        params: {
            userId,
            isDeleteEvents,
        },
    });
}
